if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.activeMediaIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.isSwiping = false;

        this.onKeyUp = this.onKeyUp.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onNavClick = this.onNavClick.bind(this);

        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchmove', this.onTouchMove, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd);

        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.addEventListener('click', this.onNavClick);
          // Prevent ModalDialog's media-modal pointerup from closing on nav clicks
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
      }

      get mediaItems() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return [];

        return Array.from(content.children).filter(
          (element) => element.hasAttribute('data-media-id') || element.querySelector('[data-media-id]')
        );
      }

      getMediaId(element) {
        return element.getAttribute('data-media-id') || element.querySelector('[data-media-id]')?.getAttribute('data-media-id');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.mediaItems;
        let index = items.findIndex((item) => this.getMediaId(item) === mediaId);
        if (index < 0) index = 0;
        this.setActiveMedia(index, { scroll: true });
      }

      setActiveMedia(index, { scroll = false } = {}) {
        const items = this.mediaItems;
        if (!items.length) return;

        const nextIndex = Math.max(0, Math.min(index, items.length - 1));
        this.activeMediaIndex = nextIndex;

        items.forEach((element, i) => {
          element.classList.toggle('active', i === nextIndex);
        });

        const activeMedia = items[nextIndex];
        if (!activeMedia) return;

        if (scroll) {
          activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavButtons();
      }

      updateNavButtons() {
        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        const total = this.mediaItems.length;

        if (prev) prev.disabled = this.activeMediaIndex <= 0 || total <= 1;
        if (next) next.disabled = this.activeMediaIndex >= total - 1 || total <= 1;
      }

      stepMedia(delta) {
        this.setActiveMedia(this.activeMediaIndex + delta);
      }

      onKeyUp(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.stepMedia(-1);
        } else if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.stepMedia(1);
        }
      }

      onNavClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const button = event.currentTarget;
        if (button.classList.contains('product-media-modal__nav--prev')) {
          this.stepMedia(-1);
        } else {
          this.stepMedia(1);
        }
      }

      onTouchStart(event) {
        if (!this.hasAttribute('open') || event.touches.length !== 1) return;
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.isSwiping = false;
      }

      onTouchMove(event) {
        if (!this.hasAttribute('open') || event.touches.length !== 1) return;
        const deltaX = event.touches[0].clientX - this.touchStartX;
        const deltaY = event.touches[0].clientY - this.touchStartY;
        if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.isSwiping = true;
        }
      }

      onTouchEnd(event) {
        if (!this.hasAttribute('open') || !this.isSwiping) return;

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;
        const threshold = 50;

        this.isSwiping = false;

        if (Math.abs(deltaX) < threshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

        // Swipe left → next; swipe right → previous
        this.stepMedia(deltaX < 0 ? 1 : -1);
      }
    }
  );
}
